import * as URL from "../helpers/Constants";
import axios from "axios";

export default class CustomerGroupService {
    static getAllCustomerGroups(page, size, id, customerGroupsName) {
        return axios.get(URL.GET_ALL_CUSTOMER_GROUPS, {
            ...CustomerGroupService.getAuthHeader(),
            params: {page, size, id, customerGroupsName}
        });
    }

    static getCustomerGroupById(id) {
        return axios.get(`${URL.GET_CUSTOMER_GROUP_BY_ID}/${id}`, CustomerGroupService.getAuthHeader());
    }

    static addCustomerGroup(data) {
        return axios.post(URL.POST_CUSTOMER_GROUP, data, CustomerGroupService.getAuthHeader());
    }

    static updateCustomerGroup(data, id) {
        return axios.put(`${URL.UPDATE_CUSTOMER_GROUP}/${id}`, data, CustomerGroupService.getAuthHeader());
    }

    static deleteCustomerGroup(id) {
        return axios.delete(`${URL.DELETE_CUSTOMER_GROUP}/${id}`, CustomerGroupService.getAuthHeader());
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        const options = {headers: {"Authorization": `Bearer ${accessToken}`}}
        return options;
    }

    // static changeCustomerGroupStatus(email, status) {
    //     return axios.post(`${URL.UPDATE_CUSTOMER_GROUP_STATUS}/${email}?status=${status}`)
    // }
}